import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const images = require.context("../qaccom2023", true);
const imageList = images.keys().map((image) => images(image));

function Comrades2023() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: "linear",
    adaptiveHeight: false,
    nextArrow: false,
    prevArrow: false,
    arrows: false,
  };
  return (
    <div className=" items-center bg-[#001ea1] pt-[120px] justify-center flex md:pb-10 md:px-48">
      <div className="container rounded-3xl shadow-2xl shadow-black object-contain ">
        <Slider {...settings}>
          {imageList.map((image, index) => (
            <img key={index} src={image} alt={`image-${index}`} />
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Comrades2023;
